import { createFeatureSelector, createSelector } from "@ngrx/store";
import { CartState } from "./cart.reducers";

const cartFeatureSelector = createFeatureSelector<CartState>('cart');

export const searchItems = createSelector(
    cartFeatureSelector,
    state => state.searchItems
);

export const searchResetSignal = createSelector(
    cartFeatureSelector,
    state => state.searchResetSignal
)

export const cartItems = createSelector(
    cartFeatureSelector,
    state => state.cartItems
);

export const cartProps = createSelector(
    cartFeatureSelector,
    state => {return {
        cartTotal: state.cartTotal,
        cartTax8: state.cartTax8,
        cartTax18: state.cartTax18,
        cartGrandTotal: state.cartGrandTotal
    } }
)

export interface CartProperties {
    cartTotal: number;
    cartTax8: number;
    cartTax18: number;
    cartGrandTotal: number;
}